import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	//console.log('test');
	Object.assign(state, defaultState);
};

export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},

	[types.SET_OPTION_PLANT_LIST]: (state, { key, list }) => {
		state[key] = list.map(item => {
			return { label: item.commCdName, value: item.commCd };
		});
	},

	[types.SET_OPTION_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'Select', value: '' }];
		list.map(item => {
			list_new.push({ label: item.commCdName, value: item.commCd });
		});
		state[key] = list_new;
	},

	[types.SET_OPTION_CODE_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'Select', value: '' }];
		list.map(item => {
			list_new.push({ label: item.codeName, value: item.code });
		});
		state[key] = list_new;
	},

	[types.SET_SCREEN_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'Select', value: '' }];
		list.map(item => {
			list_new.push({ label: item.scrId + ' ' + item.scrName, value: item.scrId });
		});
		state[key] = list_new;
	},

	[types.SET_SEARCH_PARAM]: (state, params) => {
		state.searchParams = { ...state.searchParams, ...params };
	}
};
